var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isReservedPlace(_vm.place))?_c('div',{staticClass:"place-wrapper reserved",style:({
      left: Math.round(_vm.place.X) * _vm.scaleValue + 'px',
      top: Math.round(_vm.place.Y) * _vm.scaleValue + 'px',
      background: '#59636b',
      width: 20 * _vm.scaleValue + 'px',
      height: 20 * _vm.scaleValue + 'px',
      fontSize: 16 * _vm.scaleValue + 'px',
    })},[_c('div',{staticClass:"place"},[_vm._v("\n      "+_vm._s(_vm.place.Number)+"\n    ")])]):_c('div',{staticClass:"place-wrapper",class:[{ added: _vm.addedClass }],style:({
      left: Math.round(_vm.place.X) * _vm.scaleValue + 'px',
      top: Math.round(_vm.place.Y) * _vm.scaleValue + 'px',
      background: _vm.getPlaceColor,
      width: 20 * _vm.scaleValue + 'px',
      height: 20 * _vm.scaleValue + 'px',
      fontSize: 16 * _vm.scaleValue + 'px',
    }),on:{"click":_vm.changePlaceInCart}},[_c('div',{staticClass:"place"},[_vm._v("\n      "+_vm._s(_vm.place.Number)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }